"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentPageProvider = void 0;
exports.useDocumentPage = useDocumentPage;
exports.useDocumentPageIfAny = useDocumentPageIfAny;
exports.useReadDocumentPageAgain = useReadDocumentPageAgain;
exports.useWatchedDocumentPage = useWatchedDocumentPage;
exports.useWatchedDocumentPageIfAny = useWatchedDocumentPageIfAny;
var _react = _interopRequireWildcard(require("react"));
var _pageRevisions = require("../components/chat/proposal-tracker/page-revisions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DocumentPageContext = /*#__PURE__*/(0, _react.createContext)(null);
var nextWatcherSerial = 0;
var DocumentPageProvider = exports.DocumentPageProvider = function DocumentPageProvider(_ref) {
  var pages = _ref.pages,
    children = _ref.children;
  var subscribe = (0, _react.useCallback)(function (listener) {
    return pages.subscribe(listener);
  }, [pages]);
  var currentPage = (0, _react.useCallback)(function () {
    return pages.page;
  }, [pages]);
  var documentPage = (0, _react.useSyncExternalStore)(subscribe, currentPage, currentPage);
  var page = (0, _react.useMemo)(function () {
    return (0, _pageRevisions.livePageSnapshotOf)(documentPage);
  }, [documentPage]);
  var watch = (0, _react.useCallback)(function (ownerKey, bookmarkNames) {
    return pages.watch(ownerKey, bookmarkNames);
  }, [pages]);
  var readPageAgain = (0, _react.useCallback)(function () {
    return pages.touch();
  }, [pages]);
  var value = (0, _react.useMemo)(function () {
    return {
      page: page,
      watch: watch,
      readPageAgain: readPageAgain
    };
  }, [page, watch, readPageAgain]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DocumentPageContext.Provider, {
    value: value,
    "data-sentry-element": "DocumentPageContext.Provider",
    "data-sentry-component": "DocumentPageProvider",
    "data-sentry-source-file": "DocumentPageContext.tsx",
    children: children
  });
};
function useDocumentPageContext() {
  var value = (0, _react.useContext)(DocumentPageContext);
  if (value === null) throw new Error("useDocumentPage must be used within a DocumentPageProvider");
  return value;
}
function useDocumentPage() {
  return useDocumentPageContext().page;
}
function useDocumentPageIfAny() {
  var _useContext$page, _useContext;
  return (_useContext$page = (_useContext = (0, _react.useContext)(DocumentPageContext)) === null || _useContext === void 0 ? void 0 : _useContext.page) !== null && _useContext$page !== void 0 ? _useContext$page : null;
}
var READS_NO_PAGE = function READS_NO_PAGE() {
  return undefined;
};
function useReadDocumentPageAgain() {
  var _useContext$readPageA, _useContext2;
  return (_useContext$readPageA = (_useContext2 = (0, _react.useContext)(DocumentPageContext)) === null || _useContext2 === void 0 ? void 0 : _useContext2.readPageAgain) !== null && _useContext$readPageA !== void 0 ? _useContext$readPageA : READS_NO_PAGE;
}
function useWatchedDocumentPageIfAny(bookmarkNames) {
  var _pageContext$watch, _pageContext$page;
  var followsReplyTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var pageContext = (0, _react.useContext)(DocumentPageContext);
  var watch = (_pageContext$watch = pageContext === null || pageContext === void 0 ? void 0 : pageContext.watch) !== null && _pageContext$watch !== void 0 ? _pageContext$watch : null;
  var watcherKeyRef = (0, _react.useRef)(null);
  var bookmarkKey = _toConsumableArray(bookmarkNames).sort().join("|");
  (0, _react.useEffect)(function () {
    if (watch === null) return;
    if (bookmarkKey.length === 0 && !followsReplyTargets) return;
    if (watcherKeyRef.current === null) watcherKeyRef.current = "page-watcher:".concat(nextWatcherSerial++);
    return watch(watcherKeyRef.current, bookmarkKey.length === 0 ? [] : bookmarkKey.split("|"));
  }, [bookmarkKey, followsReplyTargets, watch]);
  return (_pageContext$page = pageContext === null || pageContext === void 0 ? void 0 : pageContext.page) !== null && _pageContext$page !== void 0 ? _pageContext$page : null;
}
function useWatchedDocumentPage(bookmarkNames) {
  var followsReplyTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var watchedPage = useWatchedDocumentPageIfAny(bookmarkNames, followsReplyTargets);
  if (watchedPage === null) throw new Error("useDocumentPage must be used within a DocumentPageProvider");
  return watchedPage;
}